import DOMPurify from 'dompurify';

export function formatDate(dateString: string) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const getUtf8ByteLength = (value: string) => {
  let byteLength = 0;

  for (const char of value) {
    const codePoint = char.codePointAt(0) ?? 0;

    if (codePoint <= 0x7f) byteLength += 1;
    else if (codePoint <= 0x7ff) byteLength += 2;
    else if (codePoint <= 0xffff) byteLength += 3;
    else byteLength += 4;
  }

  return byteLength;
};

export function validateUrl(url: string, requiredParams: string[]): { isValid: boolean; missingParams: string[] } {
  try {
    const parsedUrl = new URL(url);
    const queryParams = new URLSearchParams(parsedUrl.search);

    const missingParams = requiredParams.filter((param) => !queryParams.has(param));

    return {
      isValid: missingParams.length === 0,
      missingParams,
    };
  } catch {
    return {
      isValid: false,
      missingParams: requiredParams,
    };
  }
}

export const sanitizeSearchString = (search: string): string => {
  if (!search) return '';

  try {
    const params = new URLSearchParams(search);
    const cleanParams = new URLSearchParams();

    params.forEach((value, key) => {
      const cleanKey = DOMPurify.sanitize(key);
      const cleanValue = DOMPurify.sanitize(value);

      if (cleanKey) {
        cleanParams.append(cleanKey, cleanValue);
      }
    });

    const result = cleanParams.toString();
    return result ? `?${result}` : '';
  } catch {
    return '';
  }
};
